export const TIME = {
  SECONDS_IN_MINUTE: 60,
} as const;
